import { Box, useTheme } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { type ElementType } from 'react'

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

export const CardSelectedIcon = () => {
  const theme = useTheme()
  const CheckCircleIconComponent = resolveIconComponent(CheckCircleIcon)

  return (
    <Box
      sx={{
        backgroundColorColor: theme.palette.background.paper,
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1,
        m: '8px',
      }}
    >
      <CheckCircleIconComponent
        color="primary"
        sx={{
          width: '32px',
          height: '32px',
        }}
      />
    </Box>
  )
}
